// CRT prefix rules used by both API exports and the web frontend.

export const CDC_FLETERO_PREFIXES = ["AR180", "BR180", "AR244", "BR244", "PY611", "AR611"]
export const TJ_FLETERO_PREFIXES  = ["AR572", "BR572", "CL572"]

export const isCDCFleteroPrefix = (crt: string): boolean =>
  CDC_FLETERO_PREFIXES.some(p => crt.startsWith(p))

export const isTJFleteroPrefix = (crt: string): boolean =>
  TJ_FLETERO_PREFIXES.some(p => crt.startsWith(p))

// ─── Owner detection ─────────────────────────────────────────────────────────

const nUp        = (v: string | null | undefined) => (v ?? "").trim().toUpperCase()
const nUpCompact = (v: string | null | undefined) => nUp(v).replace(/\s+/g, "")

/** Propietario del camión es CDC (ej: "TRANSPORTE C D C S A") */
export const isCDCOwner = (v: string | null | undefined): boolean =>
  nUpCompact(v).includes("CDC")

/** Propietario del camión es TJ (ej: "TRANSJOVEM...") */
export const isTJOwner = (v: string | null | undefined): boolean =>
  nUp(v).includes("TRANSJOV")

/** Propietario del camión es Kaizen (ej: "KAIZEN TRANSPORTES") */
export const isKaizenOwner = (v: string | null | undefined): boolean =>
  nUp(v).includes("KAIZEN")

/**
 * Propietario fletero: ni CDC, ni TJ, ni Kaizen.
 * En estos casos el chofer es irrelevante para todos los exports
 * (CDC fletero → reemplazado por FLETEROS VARIOS; TJ/Kaizen fletero → excluido).
 */
export const isFleteroOwner = (v: string | null | undefined): boolean =>
  !isCDCOwner(v) && !isTJOwner(v) && !isKaizenOwner(v)
